import { useEffect, useState } from "react";
import { hasConsent, setConsent } from "../lib/track";

export const ConsentBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { if (localStorage.getItem("gr_consent") === null) setShow(true); }, []);
  if (!show) return null;
  const choose = (ok) => { setConsent(ok); setShow(false); };
  return (
    <div data-testid="consent-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-sm z-[70] bg-white border border-[var(--line)] shadow-xl p-5">
      <p className="text-sm text-[var(--ink-soft)] leading-relaxed">
        Utilizziamo statistiche di utilizzo — tracking interno anonimo e, con il tuo consenso, Google Analytics — per migliorare il sito. La tua scelta non limita la navigazione.{" "}
        <a href="/cookie-policy" className="underline hover:text-[var(--petrol)]">Cookie Policy</a> · <a href="/privacy-policy" className="underline hover:text-[var(--petrol)]">Privacy Policy</a>
      </p>
      <div className="mt-4 flex gap-3">
        <button data-testid="consent-accept" onClick={() => choose(true)} className="btn-fill text-xs uppercase tracking-[0.12em] font-semibold bg-[var(--petrol)] text-white px-5 py-2.5">Accetta</button>
        <button data-testid="consent-decline" onClick={() => choose(false)} className="text-xs uppercase tracking-[0.12em] font-semibold text-[var(--ink-soft)] px-4 py-2.5">Rifiuta</button>
      </div>
    </div>
  );
};
